// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#delete-confirmation .warning-message {
  margin: 1rem 0 1rem;
  font-size: 1.5rem;
  color: var(--soft-red-color);
}

#delete-confirmation .entry-details {
  font-weight: bold;
  font-size: 1rem;
  color: var(--secondary-color);
}

#delete-confirmation .entry-details .date {
  color: var(--light-grey-color);
}

#delete-confirmation .entry-details .time {
  font-size: 2rem;
}

#delete-confirmation .entry-details .size {
  color: var(--secondary-color);
}

#delete-confirmation .entry-details .units {
  color: var(--light-grey-color);
}

#delete-confirmation .warning-message {
  color: var(--main-foreground-color);
}

#delete-confirmation .warning-button {
  font-size: 1.8rem;
  margin: 0.5rem;
  color: white;
  border-radius: 999px;
  padding: 0.5rem 0.5rem;
  cursor: pointer;
}

#delete-confirmation .delete {
  font-size: 1.5rem;
  background-color: var(--soft-red-color);
  border: 2px solid var(--soft-red-color);
}

#delete-confirmation .nevermind {
  font-size: 1.5rem;
  background-color: var(--main-foreground-color);
  border: 2px solid var(--main-foreground-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/DeleteConfirmationModal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,8CAA8C;AAChD","sourcesContent":["#delete-confirmation .warning-message {\n  margin: 1rem 0 1rem;\n  font-size: 1.5rem;\n  color: var(--soft-red-color);\n}\n\n#delete-confirmation .entry-details {\n  font-weight: bold;\n  font-size: 1rem;\n  color: var(--secondary-color);\n}\n\n#delete-confirmation .entry-details .date {\n  color: var(--light-grey-color);\n}\n\n#delete-confirmation .entry-details .time {\n  font-size: 2rem;\n}\n\n#delete-confirmation .entry-details .size {\n  color: var(--secondary-color);\n}\n\n#delete-confirmation .entry-details .units {\n  color: var(--light-grey-color);\n}\n\n#delete-confirmation .warning-message {\n  color: var(--main-foreground-color);\n}\n\n#delete-confirmation .warning-button {\n  font-size: 1.8rem;\n  margin: 0.5rem;\n  color: white;\n  border-radius: 999px;\n  padding: 0.5rem 0.5rem;\n  cursor: pointer;\n}\n\n#delete-confirmation .delete {\n  font-size: 1.5rem;\n  background-color: var(--soft-red-color);\n  border: 2px solid var(--soft-red-color);\n}\n\n#delete-confirmation .nevermind {\n  font-size: 1.5rem;\n  background-color: var(--main-foreground-color);\n  border: 2px solid var(--main-foreground-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
